const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            cancel:             'Cancelar',
            close:              'Fechar',
            config:             'Configuração',
            content:            'Conteúdo',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de conteúdos',
            dark_mode:               'Dark mode',
            dates:              'Datas',
            date_creation:      'Criação',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            description_placeholder: 'Introduza uma descrição',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            entity:             'Utilizador',  
            entity_edit:        'Editar utilizador',                
            entity_new:         'Novo utilizador',                
            entity_list:        'Lista de utilizador', 
            filter_placeholder: 'Procurar',
            id:                 'ID',
            language:           'Lingua',
            login_data:         'Dados de login',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            image:              'Imagem',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            password:           'Password',
            password_confirmation:  'Confirmação da Password',
            password_placeholder:   'Introduza a password',
            password_title:     'Password!',
            password_text:      'As Passwords não correspondem.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Dados pessoais',
            principal:          'Principal',
            profile:            'Perfil',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_thumbnail:    'Thumbnail',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_type:         'Tipo',
            table_count:        'Count',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introzuda o título',
            save:               'Salvar', 
            username:           'Username', 
            username_placeholder: 'Itroduza o username', 
            warning_title:      'Aviso!',
            warning_text:       'O username já existe no sistema.',
            warning_confirm:    'Continuar',
            warning_cancel:     'Não',
            warning_error:      'Problema ao inserir registo!',
            warning_success:    'Registo inserido com sucesso!',             
        },
    'en':
        {
            add_new:            'Add new',
            cancel:             'Cancel',
            close:              'Close',
            config:              'Clonfiguration',
            content:            'Content',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Content list',
            dates:              'Dates',
            date_creation:      'Creation',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            description_placeholder: 'Insert a description',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            entity:             'Webuser', 
            entity_edit:        'Edit user', 
            entity_new:         'New user', 
            entity_list:        'User List', 
            filter_placeholder: 'Search',
            id:                 'ID',
            language:           'Language',
            login_data:         'Login data',
            name:               'Name',
            name_placeholder:   'Insert the name',
            image:              'Image',
            image_choose:       'Choose imagem',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            password:           'Password',
            password_confirmation: 'Password confirmation',
            password_placeholder:   'Insert the password',
            password_title:     'Password!',
            password_text:      'The password do not match.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Personal data',
            principal:          'Principal',
            profile:            'Profile',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_thumbnail:    'Thumbnail',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_type:         'Type',
            table_count:        'Count',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            save:               'Save',
            username:           'Username',
            username_placeholder: 'Insert the username',
            warning_title:      'Warning!',
            warning_text:       'The username is already in the system.',
            warning_confirm:    'Continue',
            warning_cancel:     'No',
            warning_error:      'Problem inserting element!',
            warning_success:    'Successful inserted element!', 
        }
}

module.exports = {
    language
};